import React from 'react'
import Signup from '../components/SignUP/Signup'

const SignUPP = () => {
    return (
        <>
            <Signup/>
            
        </>
    )
}

export default SignUPP
